module.exports = __webpack_public_path__ + "static/media/logo02.dcd7954e.svg";